export default "__VITE_ASSET__B9$8SA7j__"